// extracted by mini-css-extract-plugin
export default {"songPoster":"SongsTable_songPoster__titjf","cellDiv":"SongsTable_cellDiv__P26Go"};